import React, { useState, useEffect } from "react";
import Header from "../../../header/Header";
import PrevBtn from "../../../common/PrevBtn";
import NextBtn from "../../../common/NextBtn";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseURL from "../../../config/Baseurl";

import Sidebar from "../../../common/Sidebar";
import { useTranslation } from 'react-i18next';
const Chapter03Screen08 = () => {
	const navigate = useNavigate();

	const [checkedQues4_1, setCheckedQues4_1] = useState('');
	const [checkedQues4_2, setCheckedQues4_2] = useState('');
	const [checkedQues4_3, setCheckedQues4_3] = useState('');
	const [checkedQues4_4, setCheckedQues4_4] = useState('');
	const [checkedQues4_5, setCheckedQues4_5] = useState('');
	const user_details = JSON.parse(localStorage.getItem('user_details'));

	  const { t, i18n } = useTranslation();

	const saveAns = () => {
		var data = JSON.stringify({
			"user_id": user_details.user_id,
			"answers": {
				"ques1": {
					"ans": "",
					"ques_id": "1"
				},
				"ques2": {
					"ans": "",
					"ques_id": "2"
				},

				"ques4": {
					"ans": checkedQues4_1,
					"ans2": checkedQues4_2,
					"ans3": checkedQues4_3,
					"ans4": checkedQues4_4,
					"ans5": checkedQues4_5,
					"ques_id": "4"
				},
				"ques5": {
					"ans": "",
					"ques_id": "5"
				}
			}
		});
		var config = {
			method: 'post',
			url: BaseURL + '/HumanRightsChapter03',
			headers: {
				'Authorization': `Bearer ${user_details.token}`,
				'Content-Type': 'application/json'
			},
			data: data
		};
		axios(config)
			.then(function (response) {
				if (response.data.success === true) {
					navigate('/module-05/chapter-03-screen-09')
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}
	useEffect(() => {
		var data = JSON.stringify({
			"user_id": user_details.user_id,
			"ques_id": ""
		});
		var config = {
			method: 'post',
			url: BaseURL + '/HumanRightsChapter03Result',
			headers: {
				'Authorization': `Bearer ${user_details.token}`,
				'Content-Type': 'application/json'
			},
			data: data
		};
		axios(config)
			.then(function (response) {
				if (response.data.success === true) {
					const results = response.data.data.chapter;
					results.map((result) => {
						console.log(result);
						checkedVal(result.ques_id.toString(), result.ans, result.ans2, result.ans3, result.ans4, result.ans5, result.ans6)
					})
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}, []);
	const checkedVal = (param, ans, ans2, ans3, ans4, ans5, ans6) => {

		if (param === '4') {
			setCheckedQues4_1(ans)
			setCheckedQues4_2(ans2)
			setCheckedQues4_3(ans3)
			setCheckedQues4_4(ans4)
			setCheckedQues4_5(ans5)
		}
	}
	const BtnDisabled = () => {
		if (checkedQues4_1 != '' || checkedQues4_2 != '' || checkedQues4_3 != '' || checkedQues4_4 != '') {
			return (
				<>
					<button
						className={`button_su`}
						data-wow-duration="1s"
						data-wow-delay="0.2s"
					>
						<span className="su_button_circle" />
						<button onClick={saveAns} className="button_su_inner">
							<span className="button_text_container">
							{t('CommonBtnGoNext')} <i className="bi bi-arrow-right" />
							</span>
						</button>
					</button>
				</>
			);
		} else {
			return (
				<>
					<button className="button_su disabled-btn" type="button" disabled="">
						<span className="su_button_circle"></span>
						<span className="button_su_inner">
							<span className="button_text_container">
								{" "}
								{t('CommonBtnGoNext')}<i className="bi bi-arrow-right" />
							</span>{" "}
						</span>
					</button>
				</>
			);
		}
	};
	return (
		<>
			<div className="wrapper md-5-bg">
				<div className="fixed-header">
					<div className="container-fluid cf-set">
						<Header leftChapter="1/4" percentage="25" star="2" />
					</div>
				</div>

				<div className="d-flex">
				<Sidebar/>
				<div className="data-adjust">
					<div className="container-fluid cf-set">
						<div className="row align-items-top justify-content-between pt-20 mt-3">

							<div
								className="col-lg-12 wow fadeInDown"
								data-wow-duration="1s"
								data-wow-delay="0.2s"
							>
								{/* <p className="mb-2">For example: If the statement is-  <b>Can travel at night safely without fear</b> {" "} </p> */}
								<h3 className="mb-2"> <b>{t('M5chapter03Screen8Text1')}</b> {" "} </h3>
							</div>
							<div
								className="col-lg-6 wow fadeInDown"
								data-wow-duration="1s"
								data-wow-delay="0.2s"
							>
								<div className=" positon-submit">
									<textarea className="form-control" rows={1} placeholder="Write Something here....."
										defaultValue={checkedQues4_1}
										onChange={(e) => setCheckedQues4_1(e.target.value)}
									/>
								</div>
								<div className="mt-1 positon-submit">
									<textarea className="form-control" rows={1} placeholder="Write Something here....."
										defaultValue={checkedQues4_2}
										onChange={(e) => setCheckedQues4_2(e.target.value)}
									/>
								</div>
								<div className="mt-1 positon-submit">
									<textarea className="form-control" rows={1} placeholder="Write Something here....."
										defaultValue={checkedQues4_3}
										onChange={(e) => setCheckedQues4_3(e.target.value)}
									/>
								</div>
								<div className="mt-1 positon-submit">
									<textarea className="form-control" rows={1} placeholder="Write Something here....."
										defaultValue={checkedQues4_4}
										onChange={(e) => setCheckedQues4_4(e.target.value)}
									/>
								</div>
								<div className="mt-1 positon-submit">
									<textarea className="form-control" rows={1} placeholder="Write Something here....."
										defaultValue={checkedQues4_5}
										onChange={(e) => setCheckedQues4_5(e.target.value)}
									/>
								</div>

							</div>
							<div
								className="col-lg-4 mt-m-3 wow fadeInDown"
								data-wow-duration="1s"
								data-wow-delay="0.2s"
							>
								<center>
									<img
										width="55%"
										draggable="false"
										src="/assets/img/md3/md3-shap-1-8.png"
										alt=""
									/>
								</center>
							</div>
						</div>
					</div>
				</div>
				</div>
				<div
					className="button-fixed wow fadeInDown"
					data-wow-duration="1s"
					data-wow-delay="0.2s"
				>
					<div className="container-fluid cf-set">
						<div className="row">
							<div className="col-lg-12">
								<div className=" d-flex justify-content-end">
									<PrevBtn link="/module-05/chapter-03-screen-07" />
									{/* <NextBtn link="/module-05/chapter-03-screen-09" text="Go Next"/> */}
									<BtnDisabled />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default Chapter03Screen08;
